import React from "react";
import MarketCategories from "../../../../../data/types/MarketCategories";

import s from "./ProductCategory.module.scss";

export default function ProductCategory({ category, onClick = () => {} }) {
	return (
		<p className={s.root} onClick={onClick}>
			Category: <span>{MarketCategories[category]}</span>
		</p>
	);
}
